import { ApiError } from '../../api/client';
import { safeReturnTo } from './returnTo';

const INTENT_KEY = 'kazna:yandex-intent';
const UUID = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/iu;
export const EMAIL_LINK_LOGIN = '/auth/email/link-login';
export type YandexIntent = {
  owner: string;
  epoch: string;
  purpose: 'sign-in' | 'email-link';
  returnTo: string;
  challengeId?: string;
};

// One tab owns one complete record across the provider redirect. Old global
// challenge/return-to keys have no originating epoch and cannot be resumed.
export function readYandexIntent(): YandexIntent | undefined {
  try {
    const value = JSON.parse(sessionStorage.getItem(INTENT_KEY) ?? 'null') as YandexIntent | null;
    if (!value || !UUID.test(value.owner) || typeof value.epoch !== 'string'
      || !value.epoch || !['sign-in', 'email-link'].includes(value.purpose)
      || typeof value.returnTo !== 'string'
      || (value.challengeId !== undefined && !UUID.test(value.challengeId))) return;
    return { owner: value.owner, epoch: value.epoch, purpose: value.purpose,
      returnTo: safeReturnTo(value.returnTo), ...(value.challengeId ? { challengeId: value.challengeId } : {}) };
  } catch { return; }
}

export function saveYandexIntent(intent: YandexIntent): void {
  // Only nonsensitive IDs, epoch, fixed purpose and allowlisted local target.
  sessionStorage.setItem(INTENT_KEY, JSON.stringify({ owner: intent.owner,
    epoch: intent.epoch, purpose: intent.purpose, returnTo: safeReturnTo(intent.returnTo),
    ...(intent.challengeId ? { challengeId: intent.challengeId } : {}) }));
}

export function ownsYandexIntent(owned: YandexIntent): boolean {
  const current = readYandexIntent();
  return current?.owner === owned.owner && current.epoch === owned.epoch
    && current.challengeId === owned.challengeId && current.purpose === owned.purpose
    && current.returnTo === owned.returnTo;
}

export function assertYandexIntent(owned: YandexIntent): void {
  if (!ownsYandexIntent(owned)) throw new ApiError(409, 'AUTH_INTENT_CHANGED', 'Вход уже изменился. Продолжите последнее начатое действие.');
}

export function clearYandexIntent(owned: YandexIntent): void {
  if (ownsYandexIntent(owned)) sessionStorage.removeItem(INTENT_KEY);
}
